<form [formGroup]="form">
  <mat-accordion class="info-accordion" [multi]="true" (ngSubmit)="submit()">
    <!----------------------------------------- PANEL 1 --------------------------------------------->
    <mat-expansion-panel class="px-0" hideToggle [expanded]="true" *ngIf="form && form.controls">
      <mat-expansion-panel-header class="ps-0">
        <mat-panel-title class="title_2">{{ "PROFILE.TITLE" | translate }}</mat-panel-title>
      </mat-expansion-panel-header>
        <!-- firstname -->
        <div>
          <mat-form-field (keyup)="checkLatin('firstname',$event)" class="w-100" *ngIf="form.controls.firstname" [ngClass]="{'disabled pointer-ev-none':!loggedinUser.isGhost }">
            <mat-label>{{ "PROFILE.FIRSTNAME" | translate }}</mat-label>
            <input matInput type="text" readonly="{{!loggedinUser.isGhost}}" [formControl]='form.controls.firstname'/>
          </mat-form-field>
          <div *ngIf="errors.firstname" class="text-danger" style="margin-top: -15px;margin-bottom: 5px;">
            {{errors.firstname }}
          </div>
        </div>

        <!-- lastname -->
        <div>
          <mat-form-field (keyup)="checkLatin('lastname',$event)" class="mt-2 w-100" *ngIf="form.controls.lastname" [ngClass]="{'disabled pointer-ev-none':!loggedinUser.isGhost }">
            <mat-label>{{ "PROFILE.LASTNAME" | translate }}</mat-label>
            <input matInput type="text" readonly="{{!loggedinUser.isGhost}}" [formControl]='form.controls.lastname'>
          </mat-form-field>
          <div *ngIf="errors.lastname" class="text-danger" style="margin-top: -15px;margin-bottom: 5px;">
            {{errors.lastname}}
          </div>
        </div>

        <!-- gender -->
        <div class="mt-2" *ngIf="form.controls.gender">
      <span class="label lightGray font-12">
        {{ "PROFILE.GENDER" | translate }} {{!loggedinUser.isGhost ? '*' : ''}}
      </span>

          <div class="d-flex justify-content-start mt-2 gap-16">
            <label class="d-flex gap-8 pointer">
              {{ "COMMON.USER.GENDER_MALE" | translate }}
              <input type="radio" class="lf-radio-input order-first pointer" formControlName="gender" value="male" [ngClass]="{'border-error': isFormSubmit && form.controls.gender.invalid}">
            </label>

            <label class="d-flex gap-8 pointer">
              {{ "COMMON.USER.GENDER_FEMALE" | translate }}
              <input type="radio" class="lf-radio-input order-first pointer" formControlName="gender" value="female" [ngClass]="{'border-error': isFormSubmit && form.controls.gender.invalid}">
            </label>
          </div>
          <div class="red-error font-12" *ngIf="isFormSubmit && form.controls.gender.invalid">
            {{ 'COMMON.IS_REQUIRED' | translate }}
          </div>
        </div>

        <!-- birthdate -->
        <div class="mt-3 mb-3" *ngIf="form.controls.birthdate">
          <div class="mb-2">
         <span class="label lightGray font-12"
           [ngClass]="{'text-danger': !isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)}">
        {{ "PROFILE.BIRTHDATE" | translate }} {{!loggedinUser.isGhost ? '*' : ''}}
      </span>
            <div class="text-danger font-12"
              *ngIf="!isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)">
              {{ 'COMMON.BIRTHDATE_FORMAT.INVALIDE' | translate }}
            </div>
          </div>
          <app-birthdate-divided #birthdayInputs
            [birthdate]="user.birthdate"
            [type]="'birthdate'"
            (newBirthdate)="setInfos($event, 'birthdate')"
            [ngClass]="{'is-invalid': !isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)}"></app-birthdate-divided>
        </div>

        <!-- birthplace -->
        <div>
          <div class="position-relative pt-2" *ngIf="form.controls.birthplace">
            <app-city-input #CityInputComponent
              class="mediumGray"
              [wantedField]="'birthplace'"
              [user]="user"
              [floatLabel]="'auto'"
              [labelContent]="'COMMON.USER.PLACEOFBIRTH' | translate"
              [cityControl]="form.controls.birthplace"
              (hasBeenClick)="hasBeenClick($event)"
              (onManualChange)="changeManualInput()"
              (onChange)="setInfos($event, 'city')"
              (keyup)="checkLatin('birthplace',$event)"></app-city-input>
            <div class="position-absolute text-success d-flex align-items-center font-12"
              *ngIf="!form.controls.birthplace.errors">
              <span class="material-icons-outlined font-12 me-1">done</span>
              {{ 'COMMON.OK_CHECKED' | translate }}
            </div>
          </div>
          <div *ngIf="errors.birthplace" class="text-danger" style="margin-bottom: 5px;">
            {{errors.birthplace}}
          </div>
        </div>

        <!-- country of birth -->
        <mat-form-field class="mt-2 w-100" *ngIf="form.controls.birthCountry">
          <mat-label>{{ 'COMMON.USER.COUNTRYOFBIRTH' | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.birthCountry'>
        </mat-form-field>

        <!-- nationality -->
        <div class="mt-4" *ngIf="form.controls.nationality">
          <mat-select-country
            label="{{'PROFILE.NATIONALITY' | translate}}"
            (onCountrySelected)="onCountrySelected($event, 'nationality')"
            [formControl]="form.controls.nationality"
            [value]="form.controls.nationality.value"
            [countries]="predefinedCountries"></mat-select-country>
        </div>
    </mat-expansion-panel>


    <!----------------------------------------- PANEL 2 --------------------------------------------->
    <mat-expansion-panel class="px-0" hideToggle [expanded]="true">
      <mat-expansion-panel-header class="ps-0">
        <mat-panel-title class="title_2">
          {{ 'COMMON.CONTACT_INFORMATIONS' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <!-- email -->
        <mat-form-field class="mt-2 w-100" *ngIf="form.controls.email" [ngClass]="{'disabled pointer-ev-none':!loggedinUser.isGhost }">
          <mat-label>{{ "COMMON.MAIL" | translate }}</mat-label>
          <input matInput type="text" readonly="{{!loggedinUser.isGhost}}" [formControl]='form.controls.email'>
        </mat-form-field>
        <!-- téléphone étranger -->
        <mat-form-field class="mt-2 w-100" *ngIf="form.controls.phone">
          <mat-label>{{ "COMMON.PHONE" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.phone'>
        </mat-form-field>
        <!-- téléphone français -->
        <mat-form-field class="mt-2 w-100" *ngIf="form.controls.studentPhone">
          <mat-label>{{ "COMMON.FRENCH_PHONE" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.studentPhone'>
        </mat-form-field>
    </mat-expansion-panel>

    <!----------------------------------------- PANEL 3 --------------------------------------------->
    <mat-expansion-panel class="px-0" hideToggle [expanded]="true">
      <mat-expansion-panel-header class="ps-0">
        <mat-panel-title class="title_2">
          {{ 'COMMON.USER.STUDY_PROJECT' | translate}}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <!-- Etablissement d'enseignement -->
        <mat-form-field *ngIf="form.controls.school" class="w-100"
          [ngClass]="{
                    'disabled pointer-ev-none':!loggedinUser.isGhost,
                    'd-none':!loggedinUser.isGhost && (loggedinUser.school.slug == 'livinfrance' || loggedinUser.school.slug == 'harvard') }
    ">
          <mat-label>{{ 'COMMON.USER.PLACE_OF_STUDY' | translate }}</mat-label>
          <mat-select [formControl]="form.controls.school">
            <mat-option value="{{school.id}}" *ngFor="let school of schools">{{ school.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Faculté/Campus -->
        <mat-form-field *ngIf="form.controls.faculty_id && faculties && faculties.length > 0" class="w-100">
          <mat-label>
            {{ (selectedSchool.slug == 'livinfrance' ? 'COMMON.USER.FACULTY_LIVINFRANCE' : 'COMMON.USER.FACULTY') | translate }}
          </mat-label>
          <mat-select [formControl]="form.controls.faculty_id">
            <mat-option value="{{faculty.id}}" *ngFor="let faculty of faculties">{{ faculty.name }}</mat-option>
          </mat-select>
          <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
        </mat-form-field>

        <!-- Ville d'étude -->
        <mat-form-field *ngIf="form.controls.studyPlace" class="w-100">
          <mat-label>{{ 'COMMON.USER.STUDY_CITY' | translate }}</mat-label>
          <mat-select [formControl]="form.controls.studyPlace">
            <mat-option value="{{city.id}}" *ngFor="let city of startingCities">{{ city.name }}</mat-option>
          </mat-select>
          <mat-error>{{ "COMMON.IS_REQUIRED" | translate }}</mat-error>
        </mat-form-field>

        <!-- Type de mobilité -->
        <mat-form-field *ngIf="form.controls.situation" class="w-100">
          <mat-label>{{ "COMMON.USER.MOBILITY_TYPE" | translate }}</mat-label>
          <mat-select [formControl]="form.controls.situation">
            <mat-option value="exchange">{{ "REGISTRATION.SITUATION.EXCHANGE" | translate }}</mat-option>
            <mat-option value="freemover">{{ "REGISTRATION.SITUATION.FREEMOVER" | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Formation -->
        <mat-form-field class="mb-2 w-100" *ngIf="form.controls.formation_id && formations && formations.length > 0">
          <mat-label>{{ "FORMATIONS.LIST_TITLE" | translate }}</mat-label>
          <mat-select disableRipple [formControl]="form.controls.formation_id">
            <mat-option [value]="formation.id" *ngFor="let formation of formations">{{ formation.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Durée du séjour -->
        <div class="position-relative mb-2" *ngIf="form.controls.stayDuration">
          <mat-form-field class="w-100" (focusin)="changeDisplayUnit()" (focusout)="changeDisplayUnit()">
            <mat-label>{{ 'PROFILE.STAY_DURATION' | translate }}</mat-label>
            <input matInput type="number" min="1" max="200" [formControl]="form.controls.stayDuration">
            <div class="input_unit" *ngIf="displayUnit || (!displayUnit && form.controls.stayDuration.value)">
              <span class="invisible">{{ form.controls.stayDuration.value }}</span>
              <span class="ms-1">
            {{ (form.controls.stayDuration.value <= 1 ? 'COMMON.MONTH' : 'COMMON.MONTHS')| translate }}
          </span>
            </div>
          </mat-form-field>
          <div class="position-absolute text-success d-flex align-items-center font-12 address-check"
            *ngIf="form.controls.stayDuration.valid">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
        </div>

        <!-- Date d'arrivée en france -->
        <div *ngIf="form.controls.arrivalDate">
          <div class="mb-2">
         <span class="label lightGray"
           [ngClass]="{'text-danger': !isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)}">
          {{ "COMMON.USER.ESTIMATE_ARRIVAL_DATE" | translate }}
        </span>
            <div class="text-danger font-12"
              *ngIf="!isBirthdayCorrect || (isFormSubmit && form.controls.birthdate.invalid)">
              {{ 'COMMON.BIRTHDATE_FORMAT.INVALIDE' | translate }}
            </div>
          </div>
          <app-birthdate-divided #ArrivalComponent
            [birthdate]="user.arrivalDate"
            [type]="'future'"
            (newBirthdate)="setInfos($event, 'arrivalDate')"
            [ngClass]="{'is-invalid': !isArrivalDateCorrect || (isFormSubmit && form.controls.arrivalDate.invalid)}"></app-birthdate-divided>
        </div>
    </mat-expansion-panel>

    <!----------------------------------------- PANEL 4 --------------------------------------------->
    <mat-expansion-panel class="px-0" hideToggle [expanded]="true">
      <mat-expansion-panel-header class="ps-0">
        <mat-panel-title class="title_2">
          {{ "COMMON.USER.LIVINPLACE_NOT_IN_FRANCE" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <!-- Adresse de résidence -->
        <mat-form-field class="w-100" *ngIf="form.controls.homeAddress">
          <mat-label>{{ "COMMON.USER.LIVIN_ADDRESS" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.homeAddress'>
        </mat-form-field>

        <!-- Complément -->
        <mat-form-field class="w-100" *ngIf="form.controls.homeAdditionalAddress">
          <mat-label>{{ "COMMON.ADDITIONAL_ADDRESS" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.homeAdditionalAddress'>
        </mat-form-field>

        <!-- COde postal de résidence  -->
        <mat-form-field class="w-100" *ngIf="form.controls.postalCode">
          <mat-label>{{ "COMMON.USER.LIVIN_CP" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.postalCode'>
        </mat-form-field>

        <!-- Ville de résidence -->
        <div class="position-relative pt-2" *ngIf="form.controls.homeCity_id">
          <app-city-input #CityInputComponent
            class="mediumGray"
            [wantedField]="'livingPlace'"
            [user]="user"
            [floatLabel]="'auto'"
            [labelContent]="'COMMON.USER.LIVIN_CITY' | translate"
            [cityControl]="form.controls.homeCity_name"
            (onChange)="setInfos($event, 'homeCity')"></app-city-input>
          <div class="position-absolute text-success d-flex align-items-center font-12"
            *ngIf="form.controls.birthplace.valid">
            <span class="material-icons-outlined font-12 me-1">done</span>
            {{ 'COMMON.OK_CHECKED' | translate }}
          </div>
        </div>

        <!-- Pays de résidence -->
        <div class="mt-4" *ngIf="form.controls.country">
          <mat-select-country
            label="{{'COMMON.USER.LIVIN_COUNTRY' | translate}}"
            (onCountrySelected)="onCountrySelected($event, 'country')"
            [formControl]="form.controls.country"
            [value]="form.controls.country.value"
            [countries]="predefinedCountries"></mat-select-country>
        </div>
    </mat-expansion-panel>
    <!----------------------------------------- PANEL 5 --------------------------------------------->
    <mat-expansion-panel class="px-0" hideToggle [expanded]="true">
      <mat-expansion-panel-header class="ps-0">
        <mat-panel-title class="title_2">
          {{ "COMMON.USER.FRENCH_ADDRESS" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <!-- Adresse française -->
        <mat-form-field class="w-100" *ngIf="form.controls.address">
          <mat-label>{{ "COMMON.USER.FRENCH_ADDRESS" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.address'>
        </mat-form-field>

        <!-- COde postal français  -->
        <mat-form-field class="w-100" *ngIf="form.controls.studentZipCode">
          <mat-label>{{ "COMMON.USER.FRENCH_CP" | translate }}</mat-label>
          <input matInput type="text" [formControl]='form.controls.studentZipCode'>
        </mat-form-field>

        <!-- Ville française -->
        <div *ngIf="form.controls.studentCity">
          <app-city-input #FrenchCityInputComponent
            class="mediumGray"
            [wantedField]="'studyPlace'"
            [user]="user"
            [floatLabel]="'auto'"
            [labelContent]="'COMMON.USER.CITY' | translate"
            [cityControl]="form.controls.studentCity"
            (onChange)="setInfos($event, 'studyCity')"></app-city-input>
        </div>
    </mat-expansion-panel>

  </mat-accordion>

  <div *ngIf="loggedinUser.isGhost" class="my-4">

    <h2 class="title_4 d-flex gap-15 mb-4">
      <lf-icon height="24px" name="fav2" width="24px"></lf-icon>
      {{"COMMON.USER.FAVORITEACCOM" | translate}}
    </h2>

    <div *ngIf="!isLoadingFav && roomsDetails && roomsDetails.length > 0" class="room_list flex-wrap w-100 d-grid">
      <app-accommodation-room-card
        *ngFor="let room of roomsDetails;trackBy:propertyTrackBy"
        [room]="room"
        class="room-component">
      </app-accommodation-room-card>
    </div>

  </div>


  <app-btn-sticky-bot (isSubmit)="submit()" [isLoading]="isLoading" [btnText]="btnConfig.name" [btnIcon]="btnConfig.btnIcon"></app-btn-sticky-bot>

</form>
